module.exports = __webpack_public_path__ + "img/28_66.7052e4c0.png";